import { InjectionToken } from '@angular/core';

export const VIDEOS_API_URL = new InjectionToken<string>('VIDEOS_API_URL');
